export const INVOICE_STATUSES = ['queued', 'created', 'signed', 'sent', 'in_review', 'approved', 'rejected', 'error', 'cancelled', 'revoked'] as const;
export type InvoiceStatus = (typeof INVOICE_STATUSES)[number];

/** Statuses offered in the murabaha list filter («Faktura» group). */
/** The murabaha queue's «Faktura» filter — the same set as Lovable. */
export const INVOICE_FILTER_STATUSES: InvoiceStatus[] = ['created', 'signed', 'in_review', 'approved', 'error'];

export const invoiceColors: Record<InvoiceStatus, string> = {
  queued: 'bg-muted text-muted-foreground',
  created: 'bg-primary/10 text-primary',
  signed: 'bg-primary/15 text-primary',
  sent: 'bg-warning/15 text-warning',
  in_review: 'bg-warning/15 text-warning',
  approved: 'bg-success/15 text-success',
  rejected: 'bg-destructive/15 text-destructive',
  error: 'bg-destructive/15 text-destructive',
  cancelled: 'bg-muted text-muted-foreground',
  revoked: 'bg-destructive/15 text-destructive',
};

export interface InvoiceParty {
  tin?: string;
  name?: string;
  address?: string;
  oked?: string;
  vatRegCode?: string;
  bankId?: string;
  account?: string;
  header?: string;
  accountant?: string;
  branchName?: string;
  branchCode?: string;
}

export interface InvoiceProduct {
  num: number;
  name: string;
  catalogCode: string;
  catalogName: string;
  barcode: string;
  packageName: string;
  amount: number;
  price: number;
  vatRate: number;
  vatSum: number;
  finalSum: number;
}

export interface InvoiceSignature {
  signer_name?: string | null;
  tin?: string | null;
  certificate_serial?: string | null;
  valid_to?: string | null;
  signed_at?: string | null;
  mock?: boolean;
}

export interface InvoiceEvent {
  id: number;
  event_type: string;
  from_status: string | null;
  to_status: string | null;
  details: Record<string, unknown> | unknown[];
  actor_name: string | null;
  created_at: string;
}

export interface Invoice {
  id: number;
  murabaha_case_id: number;
  merchant_id: number;
  doc_num: string;
  doc_date: string;
  contract_num: string;
  contract_date: string | null;
  external_id: string | null;
  /** FR-102: false in REAL — Hisob MMT signs in the Hujjat.uz cabinet (ADR-15). */
  buyer_signing?: boolean;
  external_short_id?: string | null;
  document_url?: string | null;
  /** FR-99: last Hujjat.uz callback event and when it came. */
  last_event?: string | null;
  last_event_at?: string | null;
  status: InvoiceStatus;
  total_sum: string;
  vat_sum: string;
  final_sum: string;
  seller: InvoiceParty | null;
  buyer: InvoiceParty | null;
  products: InvoiceProduct[];
  missing_fields: string[];
  signing_data: string | null;
  seller_signature: InvoiceSignature | null;
  buyer_signature: InvoiceSignature | null;
  last_error: string | null;
  reject_reason: string | null;
  sent_at: string | null;
  merchant?: { id: number; name: string; inn: string | null };
  events?: InvoiceEvent[];
}

export interface InvoiceSummary {
  id: number;
  murabaha_case_id: number;
  merchant_id: number;
  doc_num: string;
  doc_date: string;
  status: InvoiceStatus;
  final_sum: string;
  sent_at: string | null;
  reject_reason: string | null;
  merchant?: { id: number; name: string; inn: string | null };
}

export { apiErrorMessage } from '@/lib/api-error';
